export default {"id":"eb4af878","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}